import { UNREAD_NOTIFICATION_COUNT } from '@/constants/api'
import { useUnreadNotifier } from '@/utils/hooks/useUnreadNotifier'
import queryClient from '@/utils/queryClient'
import { HTMLAttributes, useCallback } from 'react'
import useNotificationSocket from './Sidebar/useNotificationSocket'

export interface NotificationServiceProps extends HTMLAttributes<HTMLDivElement> {}

export default function NotificationService({ ...props }: NotificationServiceProps) {
	const notifyUnread = useUnreadNotifier()

	useNotificationSocket({
		onUserNotification: useCallback(
			(unreadCount: number) => {
				queryClient.setQueryData([UNREAD_NOTIFICATION_COUNT], unreadCount)
				if (unreadCount > 0) {
					notifyUnread(unreadCount)
				}
			},
			[notifyUnread]
		),
	})

	return null
}
